import React, { useState, useEffect, useRef } from "react";

import EntityEdit from "../EntityEdit";
import BxApi from "../../services/bx-api";

import '../app/i18n';
import _ from "lodash";
import Mixin from "../../services/mixin";
import ErrorComponent from "../../elements/error-component"
import saveStatuses from "../../data/saveStatuses";
import logo from "./itgro_logo.png";
import { appData } from "../../data/entity_fields";
import Icon from "../../elements/icon";
import classnames from "classnames";
import Wait from "../wait";

const mixin = new Mixin();

const initialSaveStatus = saveStatuses.NOTHING_TO_SAVE;
const matchStatusesData = {
    [saveStatuses.SAVE_SUCCESSED]: { textId: 'saved', icon: 'tick' },
    [saveStatuses.SAVE_FAILED]: { textId: 'saveDataError', icon: 'warning' },
    [saveStatuses.NOTHING_TO_SAVE]: { textId: 'noUnsavedFields' },
    [saveStatuses.INVALID_UNSAVED_VALUES]: { textId: 'invalidUnsavedValues', icon: 'warning' }
};

let timer;

const restartHandler = (handler) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
        handler();
    }, 3000);
};

// TODO: тут надо рефакторить компонент на предмет работы со state, потому что тут куча полей с стейте, что порождает много всякиз setState,
// а по хорошему тут есть толька 2 вроде поля, от которых все зависит, и если так отрефакторить, то это может убрать лишние ререндеры, которые
// порождаются принудительными setState

const EntityData = ({ entity: entityFromProps, type, onBindDealChange, deals, onDealsListOpen, userTimeZone, t }) => {
    const [ entity, setEntity ] = useState(entityFromProps);
    const [ saved, setSaved ] = useState(entityFromProps);
    const [ invalidValues, setInvalidValues ] = useState([]);
    const [ saveStatus, setSaveStatus ] = useState(initialSaveStatus);// 'saveInProgress','saveSuccessed','saveFailed','nothingToSave','invalidUnsavedValues'
    const tmpSaveStatus = useRef(null);

    const changeEntity = (value, field, isValid = true) => {
        setEntity(entity => ({ ...(entity || {}), [field]: value }));
        const thisFieldIsAlreadyInvalid = invalidValues.find(val => val === field);
        let newInvalidList;
        if (!isValid) {
            !thisFieldIsAlreadyInvalid && setInvalidValues([ ...invalidValues, field ]);
            saveStatus !== saveStatuses.INVALID_UNSAVED_VALUES && setSaveStatus(saveStatuses.INVALID_UNSAVED_VALUES);
            return;
        }
        newInvalidList = invalidValues.filter(val => val !== field);
        setInvalidValues(newInvalidList);
        if (newInvalidList > 0) {
            return;
        }
        if (entityDidntChange({...entity, [field]: value})) {
            saveStatus !== saveStatuses.NOTHING_TO_SAVE && setSaveStatus(saveStatuses.NOTHING_TO_SAVE);
            return;
        }
        saveStatus !== saveStatuses.READY_TO_SAVE && setSaveStatus(saveStatuses.READY_TO_SAVE);
    };

    const saveEntity = () => {
        const bxApi = new BxApi();

        const diffFields = mixin.getObjectDiff(entity, saved);
        const diffValues = diffFields.reduce((acc, val) => ({...acc, [val]: entity[val]}), {});

        console.log('check: save entity', diffValues, Object.keys(diffValues), invalidValues);

        if (invalidValues.length > 0) {
            console.log('попытка сохранить, но есть невалидные значения', invalidValues.reduce((acc, val) => ({
                ...acc, [val]: entity[val]
            }), {}));
            setSaveStatus(saveStatuses.INVALID_UNSAVED_VALUES);
            return;
        }

        setSaveStatus(saveStatuses.SAVE_IN_PROGRESS);

        bxApi
            .crmEntityUpdate(type, entity.ID, diffValues)
            .then(async (result) => {
                if (!result) {
                    setSaveStatus(saveStatuses.SAVE_FAILED);
                    return;
                }
                setSaveStatus(saveStatuses.SAVE_SUCCESSED);
                setInvalidValues([]);
                setTimeout(() => {
                    tmpSaveStatus?.current === saveStatuses.SAVE_SUCCESSED && setSaveStatus(initialSaveStatus);
                }, 3600);
                const newEntity = await getEntity();
                console.log('new entity after saving', newEntity, diffFields.reduce((acc, val) => ({...acc, [val]: newEntity[val]}), {}));
                if (!newEntity) {
                    return;
                }
                setEntity(newEntity);
                setSaved(newEntity);
            })
            .catch((err) => {
                tmpSaveStatus?.current === saveStatuses.SAVE_IN_PROGRESS && setSaveStatus(saveStatuses.SAVE_FAILED);
            });
    };

    const getEntity = async () => {
        const bxApi = new BxApi();
        return await bxApi.rest(`crm.${type}.get`, { id: entity.ID })
            .then(entity => {
                return entity;
            })
            .catch((err) => {
                return null;
            });
    }

    const entityDidntChange = (entity1 = entity) => {
        const { DATE_MODIFY: _1, ...oldEntity } = saved;
        const { DATE_MODIFY: _2, ...newEntity } = entity1;
        return _.isEqual(oldEntity, newEntity);
    };

    const checkHandler = () => {
        if (!entityDidntChange()) {
            saveEntity();
            restartHandler(checkHandler);
        }
    };

    useEffect(() => {
        restartHandler(checkHandler);
    }, [entity, saved]);
    useEffect(() => {
        tmpSaveStatus.current = saveStatus;
    }, [saveStatus]);
    
    if (entity === null) {
        return <Wait label={t('loading')} />;
    }

    const buttonDisabled = [
        saveStatuses.NOTHING_TO_SAVE, saveStatuses.SAVE_IN_PROGRESS, 
        saveStatuses.INVALID_UNSAVED_VALUES, saveStatuses.SAVE_SUCCESSED
    ].includes(saveStatus);

    const saveButtonClassName = classnames(`btn`, {
        "btn--gray": buttonDisabled,
        "btn--success": !buttonDisabled
    });
    const messageClassName = classnames(`message`, {
        _green: saveStatus === saveStatuses.SAVE_SUCCESSED,
        _red: saveStatus === saveStatuses.SAVE_FAILED || saveStatus === saveStatuses.INVALID_UNSAVED_VALUES,
        _gray: saveStatus === saveStatuses.NOTHING_TO_SAVE
    });
    const messageTextData = matchStatusesData[saveStatus];

    return (
        <ErrorComponent>
            <EntityEdit
                entity={entity}
                type={type}
                changeEntity={changeEntity}
                saveEntity={saveEntity}
                saveStatus={saveStatus}
                onBindDealChange={onBindDealChange}
                deals={deals}
                onDealsListOpen={onDealsListOpen}
                userTimeZone={userTimeZone}
            />
            <div className="btn-group btn-group--fixed btn-group--space-between" style={{ paddingLeft: 30, paddingRight: 30 }}>
                <a
                    href="https://www.bitrix24.ru/apps/?partner_id=236534&search=Y"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                >
                    <img src={logo} alt="itgro_logo" />
                </a>

                <button
                    type="button"
                    onClick={saveEntity}
                    className={saveButtonClassName}
                    style={{ position: "relative" }}
                    disabled={buttonDisabled}
                >
                    <div style={{ display: 'inline-flex', marginTop: 4 }}>{t('save')}</div>
                    {messageTextData ? (
                        <div className={messageClassName}>
                            {messageTextData.icon ? (
                                <span className="message__icon">
                                    <Icon
                                        type={messageTextData.icon}
                                        inheritColor={true}
                                        inheritSize={true}
                                    />
                                </span>
                            ) : ``}
                            <span>{messageTextData.textId ? t(messageTextData.textId) : ``}</span>
                        </div>
                    ) : ``}
                </button>
                <div>{appData.name + ' v' + appData.version}</div>
            </div>
        </ErrorComponent>
    );
}

export default EntityData;